import { useState } from 'react';
import './Page.css';

const API_URL = 'https://nxnhzwo6bjmzf5wo6verng4hjy0zswuu.lambda-url.us-east-1.on.aws/';

export default function Contact() {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.target;
    const body = JSON.stringify({
      name: form.name.value,
      email: form.email.value,
      message: form.message.value,
    });
    try {
      await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });
      setStatus('sent');
      form.reset();
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="page">
      <h1>Contact Us</h1>
      <p>Ready to accelerate your HPC workloads? Reach us at <a href="mailto:contact@firstgradient.com">contact@firstgradient.com</a> or use the form below.</p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <label htmlFor="name">Name</label>
        <input id="name" name="name" type="text" required />

        <label htmlFor="email">Email</label>
        <input id="email" name="email" type="email" required />

        <label htmlFor="message">Message</label>
        <textarea id="message" name="message" rows="5" required></textarea>

        <button type="submit" className="btn-primary" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending...' : 'Send Message'}
        </button>
        {status === 'sent' && <p style={{ color: 'var(--accent)' }}>Message sent — we'll be in touch!</p>}
        {status === 'error' && <p style={{ color: '#ff4444' }}>Something went wrong. Please email us directly.</p>}
      </form>
    </div>
  );
}
